import { VNode } from "@stencil/core";

export interface TableRow {
    selected?: boolean;
}
export interface TableRowWithId {
    _uicTableInternalId?: string;
    selected?: boolean;
}

export interface Column {
    label?: string;
    field?: string;
    sortable?: boolean;
    group?: boolean;
    sortField?: string;
    filterable?: boolean;
    filterEmptyAndDuplicateItems?: boolean;
    customFilterItems?: [];
    getColumnMethods: () => Promise<{
        renderHeader: (tableState: object) => VNode[];
        renderCell: (row: TableRowWithId, tableState: object) => VNode[];
        getSortString?: (row: TableRowWithId) => string;
    }>;
}
